import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectBaseVictorsMedicalTugo, makeSelectBaseVictorsMedicalTugoErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import PageSectionHeader from '../components/PageSectionHeader';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormFields,
} from './actions';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR, MEDICAL_EXPENSE_TYPES } from './constants';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation/';
import { required } from '../../../utils/validation/validator';
import { AdditionalList } from './components/Additional';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled, makeSelectFormHasChanges } from '../../App/selectors';
import { setFormHasChanges } from '../../App/actions';
import FlexBox from '../../../components/FlexBox';
import FNOLTooltip from '../../../components/FNOLTooltip';
import { stepBaseVictorsMedicalTugoLookup } from '../dataMapper/claimCodeMapper';
import WizardNavigationButtons from '../components/WizardNavigationButtons';

export class BaseVictorsMedicalTugo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };

    this.radioFormResets = {
      ambulanceGroundService: {
        true: ['infoGroundAmbulanceItems'],
        false: ['infoGroundAmbulanceItems', 'ambulanceAirService', 'infoAirAmbulanceItems'],
      },
      ambulanceAirService: {
        true: ['infoAirAmbulanceItems'],
        false: ['infoAirAmbulanceItems'],
      },
      // Doctor Visit fields
      doctorVisitTelemedicine: {
        true: [],
        false: ['infoTelemedicineItems'],
      },
      doctorVisitFirstVisit: {
        true: ['infoOutpatientPhysicianFeesItems'],
        false: ['infoOutpatientPhysicianFeesItems'],
      },
      doctorVisitFollowUp: {
        true: ['infoFollowUpVisitItems'],
        false: ['infoFollowUpVisitItems', 'doctorVisitFollowUpFracture', 'infoFollowUpFractureItems'],
      },
      doctorVisitFollowUpFracture: {
        true: ['infoFollowUpFractureItems'],
        false: ['infoFollowUpFractureItems'],
      },
    };


    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      this.props.setFormHasChanges(true);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(6);
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  handleExpensesSelected = (propertyName) => (event) => {
    const { whatExpensesAreYouClaimingFor } = this.props.form;
    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    const listChecked = _.cloneDeep(expensesSelected);

    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      // Reset form fields when unchecking new medical expense types
      if (name === "Doctor's Visit") {
        this.props.onResetFormCustom([
          'doctorVisitTelemedicine',
          'infoTelemedicineItems',
          'doctorVisitFirstVisit',
          'doctorVisitFollowUp',
          'doctorVisitFollowUpFracture',
          'infoOutpatientPhysicianFeesItems',
          'infoFollowUpVisitItems',
          'infoFollowUpFractureItems',
        ]);
      }
      if (name === 'Diagnostic Tests') {
        this.props.onResetFormCustom(['infoDiagnosticTestsItems']);
      }
      if (name === 'Prescription Drugs') {
        this.props.onResetFormCustom(['infoPrescriptionDrugsItems']);
      }
      if (name === 'Ambulance Services') {
        this.props.onResetFormCustom([
          'ambulanceGroundService',
          'ambulanceAirService',
          'infoGroundAmbulanceItems',
          'infoAirAmbulanceItems',
        ]);
      }
      if (name === 'Hospitalization') {
        this.props.onResetFormCustom([
          'hospitalizationHospitalInvoice',
          'hospitalizationPhysicianInvoice',
          'hospitalizationLabDiagnostic',
          'hospitalizationOtherRelated',
          'infoHospitalFeesItems',
          'infoInpatientPhysicianFeesItems',
          'infoXrayLabsDiagnosticsItems',
          'infoOtherHospitalizationItems',
        ]);
      }
      if (name === 'Essential Medical Appliances') {
        this.props.onResetFormCustom(['infoEssentialMedicalAppliancesItems']);
      }
      if (name === 'Private Duty Nursing') {
        this.props.onResetFormCustom(['infoPrivateDutyNursingItems']);
      }
      if (name === 'Fracture Treatment') {
        this.props.onResetFormCustom(['infoFractureTreatmentItems']);
      }
      if (name === MEDICAL_EXPENSE_TYPES.OTHER_UNRELATED_BENEFIT) {
        this.props.onResetFormCustom(['infoOtherUnrelatedBenefitItems']);
      }
    }
    this.props.onFormDataChange(propertyName, listChecked);
    this.props.setFormHasChanges(true);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  // Render checkbox for Doctor's Visit
  // eslint-disable-next-line react/sort-comp
  renderDoctorVisitCheckbox = (expensesSelected, isReadOnly) => {
    const checkboxValue = "Doctor's Visit";
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxDoctorVisit} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <span>
            <div className="col-sm-12 form-group">
              {this.renderDoctorVisitQuestions()}
            </div>
          </span>
        )}
      </div>
    );
  };

  // Render checkbox for Diagnostic Tests
  renderDiagnosticTestsCheckbox = (expensesSelected, isReadOnly) => {
    const checkboxValue = 'Diagnostic Tests';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxDiagnosticTests} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderDiagnosticTestsExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Prescription Drugs
  renderPrescriptionDrugsCheckbox = (expensesSelected, isReadOnly) => {
    const checkboxValue = 'Prescription Drugs';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxPrescriptionDrugs} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderPrescriptionDrugsExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Ambulance Services
  renderAmbulanceServicesCheckbox = (expensesSelected, isReadOnly) => {
    const checkboxValue = 'Ambulance Services';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxAmbulanceServices} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderAmbulanceServicesQuestions()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Hospitalization
  renderHospitalizationCheckbox = (expensesSelected, isReadOnly) => {
    const checkboxValue = 'Hospitalization';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxHospitalization} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderHospitalizationQuestions()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Essential Medical Appliances
  renderEssentialMedicalAppliancesCheckbox = (expensesSelected, isReadOnly) => {
    const { intl } = this.props;
    const checkboxValue = 'Essential Medical Appliances';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxEssentialMedicalAppliances} />
        </span>
        <FNOLTooltip
          dataFor="essential-medical-appliances-tooltip"
          content={intl.formatMessage(messages.tooltipEssentialMedicalAppliances)}
        />
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderEssentialMedicalAppliancesExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Private Duty Nursing
  renderPrivateDutyNursingCheckbox = (expensesSelected, isReadOnly) => {
    const { intl } = this.props;
    const checkboxValue = 'Private Duty Nursing';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxPrivateDutyNursing} />
        </span>
        <FNOLTooltip
          dataFor="private-duty-nursing-tooltip"
          content={intl.formatMessage(messages.tooltipPrivateDutyNursing)}
        />
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderPrivateDutyNursingExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Fracture Treatment
  renderFractureTreatmentCheckbox = (expensesSelected, isReadOnly) => {
    const { intl } = this.props;
    const checkboxValue = 'Fracture Treatment';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxFractureTreatment} />
        </span>
        <FNOLTooltip
          dataFor="fracture-treatment-tooltip"
          content={intl.formatMessage(messages.tooltipFractureTreatment)}
        />
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderFractureTreatmentExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Other Unrelated Benefit
  renderOtherUnrelatedBenefitCheckbox = (expensesSelected, isReadOnly) => {
    const checkboxValue = MEDICAL_EXPENSE_TYPES.OTHER_UNRELATED_BENEFIT;
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxOtherUnrelatedBenefit} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderOtherUnrelatedBenefitExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Render Other (unrelated to any benefit) expenses
  renderOtherUnrelatedBenefitExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoOtherUnrelatedBenefitItems')}
    </div>
  );

  // Render Doctor's Visit questions and expense forms
  renderDoctorVisitQuestions = () => {
    const { form, isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="ml-2">
        {/* Question: Did you have your visit by telephone or video call? (Telemedicine Benefit) */}
        <div className="col-sm-12 form-group">
          <div className="mt-2">
            <PageSectionHeader>
              <FormattedMessage {...messages.questionDidYouHaveYourVisitByTelephoneOrVideoCall} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={form.doctorVisitTelemedicine === 'true'}
                  onChange={this.handleRadioButtonChange('form.doctorVisitTelemedicine')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={form.doctorVisitTelemedicine === 'false'}
                  onChange={this.handleRadioButtonChange('form.doctorVisitTelemedicine')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          {form.doctorVisitTelemedicine === 'true' && (
            <div className="mt-2">
              <b className="pt-2"><FormattedMessage {...messages.headerTelemedicineBenefit} /></b>
              {this.renderExpensesItems('infoTelemedicineItems')}
            </div>
          )}
        </div>

        {/* Question: First visit */}
        <div className="col-sm-12 form-group">
          <div className="mt-2">
            <PageSectionHeader>
              <FormattedMessage {...messages.questionFirstVisitIllnessAccident} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={form.doctorVisitFirstVisit === 'true'}
                  onChange={this.handleRadioButtonChange('form.doctorVisitFirstVisit')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={form.doctorVisitFirstVisit === 'false'}
                  onChange={this.handleRadioButtonChange('form.doctorVisitFirstVisit')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          {form.doctorVisitFirstVisit === 'true' && (
            <div className="mt-2">
              <b className="pt-2"><FormattedMessage {...messages.headerOutpatientPhysicianFees} /></b>
              {this.renderExpensesItems('infoOutpatientPhysicianFeesItems')}
            </div>
          )}
        </div>

        {/* Question: Follow up visit */}
        {form.doctorVisitFirstVisit === 'false' && (
          <div className="col-sm-12 form-group ml-4">
            <div className="mt-2">
              <PageSectionHeader>
                <FormattedMessage {...messages.questionFollowUpVisit} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={form.doctorVisitFollowUp === 'true'}
                    onChange={this.handleRadioButtonChange('form.doctorVisitFollowUp')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={form.doctorVisitFollowUp === 'false'}
                    onChange={this.handleRadioButtonChange('form.doctorVisitFollowUp')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
            {form.doctorVisitFollowUp === 'true' && (
              <div className="mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerFollowUpVisit} /></b>
                {this.renderExpensesItems('infoFollowUpVisitItems')}
              </div>
            )}

            {/* Question: Follow up visit for fracture - shown when previous answer is No */}
            {form.doctorVisitFollowUp === 'false' && (
              <div className="col-sm-12 form-group ml-4">
                <div className="mt-2">
                  <PageSectionHeader>
                    <FormattedMessage {...messages.questionFollowUpVisitFracture} />
                  </PageSectionHeader>
                  <FlexBox>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="true"
                        checked={form.doctorVisitFollowUpFracture === 'true'}
                        onChange={this.handleRadioButtonChange('form.doctorVisitFollowUpFracture')}
                      />
                      <FormattedMessage {...messages.yes} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="false"
                        checked={form.doctorVisitFollowUpFracture === 'false'}
                        onChange={this.handleRadioButtonChange('form.doctorVisitFollowUpFracture')}
                      />
                      <FormattedMessage {...messages.no} />
                    </OptionsContainer>
                  </FlexBox>
                </div>
                {form.doctorVisitFollowUpFracture === 'true' && (
                  <div className="mt-2">
                    <b className="pt-2"><FormattedMessage {...messages.headerFractureTreatment} /></b>
                    {this.renderExpensesItems('infoFollowUpFractureItems')}
                  </div>
                )}
                {form.doctorVisitFollowUpFracture === 'false' && (
                  <div className="mt-2 alert alert-danger">
                    <FormattedMessage {...messages.messageNoOngoingCare} />
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Render Diagnostic Tests expense form
  renderDiagnosticTestsExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoDiagnosticTestsItems')}
    </div>
  );

  // Render Prescription Drugs expense form
  renderPrescriptionDrugsExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoPrescriptionDrugsItems')}
    </div>
  );

  // Render Essential Medical Appliances expenses
  renderEssentialMedicalAppliancesExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoEssentialMedicalAppliancesItems')}
    </div>
  );

  // Render Private Duty Nursing expenses
  renderPrivateDutyNursingExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoPrivateDutyNursingItems')}
    </div>
  );

  // Render Fracture Treatment expenses
  renderFractureTreatmentExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoFractureTreatmentItems')}
    </div>
  );

  // Render Ambulance Services questions
  renderAmbulanceServicesQuestions = () => {
    const { form, isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="ml-4">
        {/* Ground Ambulance Question */}
        <div className="mt-2">
          <PageSectionHeader>
            <FormattedMessage {...messages.questionGroundAmbulance} />
          </PageSectionHeader>
          <FlexBox>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                value="true"
                checked={form.ambulanceGroundService === 'true'}
                onChange={this.handleRadioButtonChange('form.ambulanceGroundService')}
              />
              <FormattedMessage {...messages.yes} />
            </OptionsContainer>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                value="false"
                checked={form.ambulanceGroundService === 'false'}
                onChange={this.handleRadioButtonChange('form.ambulanceGroundService')}
              />
              <FormattedMessage {...messages.no} />
            </OptionsContainer>
          </FlexBox>
        </div>
        {form.ambulanceGroundService === 'true' && (
          <div className="mt-2">
            <b className="pt-2"><FormattedMessage {...messages.headerGroundAmbulance} /></b>
            {this.renderExpensesItems('infoGroundAmbulanceItems')}
          </div>
        )}

        {/* Air Ambulance Question - Only show if Ground Ambulance is "No" */}
        {form.ambulanceGroundService === 'false' && (
          <div className="ml-4">
            <div className="mt-2">
              <PageSectionHeader>
                <FormattedMessage {...messages.questionAirAmbulance} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={form.ambulanceAirService === 'true'}
                    onChange={this.handleRadioButtonChange('form.ambulanceAirService')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={form.ambulanceAirService === 'false'}
                    onChange={this.handleRadioButtonChange('form.ambulanceAirService')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
            {form.ambulanceAirService === 'true' && (
              <div className="mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerAirAmbulance} /></b>
                {this.renderExpensesItems('infoAirAmbulanceItems')}
              </div>
            )}
            {form.ambulanceAirService === 'false' && (
              <div className="mt-2">
                <b className="pt-2"><FormattedMessage {...messages.otherTypesOfAmbulance} /></b>
                {this.renderExpensesItems('infoGroundAmbulanceItems')}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Render Hospitalization questions
  renderHospitalizationQuestions = () => {
    const { form, isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="ml-2">
        {/* Hospital Invoice Question */}
        <div className="mt-2">
          <PageSectionHeader>
            <FormattedMessage {...messages.questionHospitalInvoice} />
          </PageSectionHeader>
          <FlexBox>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                value="true"
                checked={form.hospitalizationHospitalInvoice === 'true'}
                onChange={this.handleChange('form.hospitalizationHospitalInvoice')}
              />
              <FormattedMessage {...messages.yes} />
            </OptionsContainer>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                value="false"
                checked={form.hospitalizationHospitalInvoice === 'false'}
                onChange={this.handleChange('form.hospitalizationHospitalInvoice')}
              />
              <FormattedMessage {...messages.no} />
            </OptionsContainer>
          </FlexBox>
        </div>
        {form.hospitalizationHospitalInvoice === 'true' && (
          <div className="mt-2">
            <b className="pt-2"><FormattedMessage {...messages.headerHospitalFees} /></b>
            {this.renderExpensesItems('infoHospitalFeesItems')}
          </div>
        )}

        {/* Physician Invoice Question - Only show if Hospital Invoice is "No" */}
        {form.hospitalizationHospitalInvoice === 'false' && (
          <div className="ml-2">
            <div className="mt-2">
              <PageSectionHeader>
                <FormattedMessage {...messages.questionPhysicianInvoice} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={form.hospitalizationPhysicianInvoice === 'true'}
                    onChange={this.handleChange('form.hospitalizationPhysicianInvoice')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={form.hospitalizationPhysicianInvoice === 'false'}
                    onChange={this.handleChange('form.hospitalizationPhysicianInvoice')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
            {form.hospitalizationPhysicianInvoice === 'true' && (
              <div className="mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerInpatientPhysicianFees} /></b>
                {this.renderExpensesItems('infoInpatientPhysicianFeesItems')}
              </div>
            )}
          </div>
        )}

        {/* Lab/Diagnostic Facility Question - Only show if Hospital Invoice is "No" AND Physician Invoice is "No" */}
        {form.hospitalizationHospitalInvoice === 'false' && form.hospitalizationPhysicianInvoice === 'false' && (
          <div className="ml-3">
            <div className="mt-2">
              <PageSectionHeader>
                <FormattedMessage {...messages.questionLabDiagnosticFacility} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={form.hospitalizationLabDiagnostic === 'true'}
                    onChange={this.handleChange('form.hospitalizationLabDiagnostic')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={form.hospitalizationLabDiagnostic === 'false'}
                    onChange={this.handleChange('form.hospitalizationLabDiagnostic')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
            {form.hospitalizationLabDiagnostic === 'true' && (
              <div className="mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerXrayLabsOtherDiagnostics} /></b>
                {this.renderExpensesItems('infoXrayLabsDiagnosticsItems')}
              </div>
            )}
          </div>
        )}

        {/* Other Hospitalization Related Question - Only show if all previous questions are "No" */}
        {form.hospitalizationHospitalInvoice === 'false' &&
          form.hospitalizationPhysicianInvoice === 'false' &&
          form.hospitalizationLabDiagnostic === 'false' && (
            <div className="ml-3">
              <div className="col-sm-12 form-group">
                <PageSectionHeader>
                  <FormattedMessage {...messages.questionOtherHospitalizationRelated} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={form.hospitalizationOtherRelated === 'true'}
                      onChange={this.handleChange('form.hospitalizationOtherRelated')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={form.hospitalizationOtherRelated === 'false'}
                      onChange={this.handleChange('form.hospitalizationOtherRelated')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
              {form.hospitalizationOtherRelated === 'true' && (
                <div className="mt-2">
                  <b className="pt-2"><FormattedMessage {...messages.headerXrayLabsOtherDiagnosticsOther} /></b>
                  {this.renderExpensesItems('infoOtherHospitalizationItems')}
                </div>
              )}
            </div>
          )}
      </div>
    );
  };

  // Master render function for all medical expense checkboxes
  renderAllMedicalExpenseCheckboxes = (expensesSelected, isReadOnly, claimCodeChecks) => {
    const checkboxes = [
      {
        render: this.renderDoctorVisitCheckbox,
        key: 'doctorVisit',
        shouldRender: claimCodeChecks.isRenderDoctorVisit,
      },
      {
        render: this.renderDiagnosticTestsCheckbox,
        key: 'diagnosticTests',
        shouldRender: claimCodeChecks.isRenderDiagnosticTests,
      },
      {
        render: this.renderPrescriptionDrugsCheckbox,
        key: 'prescriptionDrugs',
        shouldRender: claimCodeChecks.isRenderPrescriptionDrugs,
      },
      {
        render: this.renderAmbulanceServicesCheckbox,
        key: 'ambulanceServices',
        shouldRender: claimCodeChecks.isRenderAmbulanceServices,
      },
      {
        render: this.renderHospitalizationCheckbox,
        key: 'hospitalization',
        shouldRender: claimCodeChecks.isRenderHospitalization,
      },
      {
        render: this.renderEssentialMedicalAppliancesCheckbox,
        key: 'essentialMedicalAppliances',
        shouldRender: claimCodeChecks.isRenderEssentialMedicalAppliances,
      },
      {
        render: this.renderPrivateDutyNursingCheckbox,
        key: 'privateDutyNursing',
        shouldRender: claimCodeChecks.isRenderPrivateDutyNursing,
      },
      {
        render: this.renderFractureTreatmentCheckbox,
        key: 'fractureTreatment',
        shouldRender: claimCodeChecks.isRenderFractureTreatment,
      },
      {
        render: this.renderOtherUnrelatedBenefitCheckbox,
        key: 'otherUnrelatedBenefit',
        shouldRender: claimCodeChecks.isRenderOtherUnrelatedBenefit,
      },
    ];

    return (
      <div className="pt-2 col-sm-12">
        {checkboxes
          .filter(({ shouldRender }) => shouldRender)
          .map(({ render, key }) => (
            <div key={key} className="mb-3">
              {render(expensesSelected, isReadOnly)}
            </div>
          ))}
      </div>
    );
  };

  // Generic handler for all expense type changes
  handleExpenseTypeChange = (formField) => (data) => {
    this.props.onFormDataChange(`form.${formField}`, fromJS(data));
    this.props.setFormHasChanges(true);
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.handleFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  /** True when at least one expense row exists in any Base Victors Medical benefit section */
  hasAnyExpenseItems = () => {
    const f = this.props.form;
    return _.some([
      f.infoTelemedicineItems,
      f.infoOutpatientPhysicianFeesItems,
      f.infoFollowUpVisitItems,
      f.infoFollowUpFractureItems,
      f.infoDiagnosticTestsItems,
      f.infoPrescriptionDrugsItems,
      f.infoGroundAmbulanceItems,
      f.infoAirAmbulanceItems,
      f.infoHospitalFeesItems,
      f.infoInpatientPhysicianFeesItems,
      f.infoXrayLabsDiagnosticsItems,
      f.infoOtherHospitalizationItems,
      f.infoEssentialMedicalAppliancesItems,
      f.infoPrivateDutyNursingItems,
      f.infoFractureTreatmentItems,
      f.infoOtherUnrelatedBenefitItems,
    ], (arr) => Array.isArray(arr) && arr.length > 0);
  };

  checkFormError() {
    const { doctorVisitFollowUp, doctorVisitFollowUpFracture } = this.props.form;

    // Check if both follow-up questions are answered with 'false' (ongoing care not covered)
    const isOngoingCareRejected = doctorVisitFollowUp === 'false' && doctorVisitFollowUpFracture === 'false';

    // Keep normal field validation; only relax the "ongoing care not covered" block
    // when the user has entered at least one expense item somewhere else.
    const hasAnyExpense = this.hasAnyExpenseItems();
    const valid = this.validatorGroup.checkValidation() && (!isOngoingCareRejected || hasAnyExpense);
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
  };

  // Generic handler for radio button changes that clears related fields
  // Usage: onChange={this.handleRadioButtonChange('form.fieldName')}
  // This handler automatically clears related form fields based on radioFormResets configuration
  handleRadioButtonChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.value;

    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);

    // Get the field name from propertyName (e.g., 'form.ambulanceGroundService' -> 'ambulanceGroundService')
    const fieldName = propertyName.replace('form.', '');

    // Check if we have reset mappings for this field
    if (this.radioFormResets[fieldName] && this.radioFormResets[fieldName][value]) {
      this.props.onResetFormCustom(this.radioFormResets[fieldName][value]);
    }
  };

  handleChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^\d*(\.\d{0,2})?$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value)) {
      this.props.onFormDataChange(propertyName, value);
      this.props.setFormHasChanges(true);
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
      this.props.setFormHasChanges(true);
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    const { doctorVisitFollowUp, doctorVisitFollowUpFracture } = this.props.form;
    const isOngoingCareRejected = doctorVisitFollowUp === 'false' && doctorVisitFollowUpFracture === 'false';
    const hasAnyExpense = this.hasAnyExpenseItems();

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation() && (!isOngoingCareRejected || hasAnyExpense);

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.handleFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
    this.props.setFormHasChanges(false);
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(6);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
  };

  // Generic render method for all expense type items
  renderExpensesItems(formField) {
    const items = this.props.form[formField];
    if (!items) {
      return null;
    }

    const newMedicalExpenseItems = this.appendIds(items);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled, intl } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.handleExpenseTypeChange(formField)}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
          intl={intl}
        />
      </div>
    );
  }

  render() {
    const {
      whatExpensesAreYouClaimingFor,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];

    // Check if medical benefits have claim codes
    const claimCodeChecks = {
      isRenderDoctorVisit: !!stepBaseVictorsMedicalTugoLookup.outpatientPhysicianFees.claimCode || !!stepBaseVictorsMedicalTugoLookup.followUpVisit.claimCode,
      isRenderDiagnosticTests: !!stepBaseVictorsMedicalTugoLookup.diagnosticTests.claimCode,
      isRenderPrescriptionDrugs: !!stepBaseVictorsMedicalTugoLookup.prescriptionDrugs.claimCode,
      isRenderAmbulanceServices: !!stepBaseVictorsMedicalTugoLookup.groundAmbulance.claimCode || !!stepBaseVictorsMedicalTugoLookup.airAmbulance.claimCode,
      isRenderHospitalization: !!stepBaseVictorsMedicalTugoLookup.hospitalFees.claimCode || !!stepBaseVictorsMedicalTugoLookup.inpatientPhysicianFees.claimCode || !!stepBaseVictorsMedicalTugoLookup.xrayLabsDiagnostics.claimCode || !!stepBaseVictorsMedicalTugoLookup.otherHospitalization.claimCode,
      isRenderEssentialMedicalAppliances: !!stepBaseVictorsMedicalTugoLookup.essentialMedicalAppliances.claimCode,
      isRenderPrivateDutyNursing: !!stepBaseVictorsMedicalTugoLookup.privateDutyNursing.claimCode,
      isRenderFractureTreatment: !!stepBaseVictorsMedicalTugoLookup.fractureTreatment.claimCode,
      isRenderOtherUnrelatedBenefit: !!stepBaseVictorsMedicalTugoLookup.otherUnrelatedBenefit.claimCode || (stepBaseVictorsMedicalTugoLookup.otherUnrelatedBenefit.associatedClaimCodes && stepBaseVictorsMedicalTugoLookup.otherUnrelatedBenefit.associatedClaimCodes.length > 0),
    };

    return (
      <div className="app-content">
        <div>
          <div className="col-sm-12 form-group">
            <PageSectionHeader>
              <FormattedMessage {...messages.thisSectionRelatedToMedicalExpenses} />
            </PageSectionHeader>
          </div>
          <div className="col-sm-12 form-group">
            <Validate
              name="whatExpensesAreYouClaimingFor"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={expensesSelected}
              fieldName={messages.whatExpensesAreYouClaimingFor}
            >
              {/* Render all medical expense checkboxes using master render function */}
              {this.renderAllMedicalExpenseCheckboxes(expensesSelected, isReadOnly, claimCodeChecks)}
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.whatExpensesAreYouClaimingFor}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        {!isSummary && (
          <WizardNavigationButtons
            onBack={this.props.prev}
            onNext={this.handleNext}
            onSave={this.handleSaveButtonClick}
            canMoveNext
            listLength={1}
            submitted={submitted}
            loading={loading}
            saveButtonId={this.saveButtonId}
            showSpinnerForElement={this.showSpinnerForElement}
            handleKeyDown={this.handleKeyDown}
            intl={intl}
            hasFormChanges={this.props.hasFormChanges}
            nextButtonRef={(ref) => {
              this.nextButton = ref;
            }}
          />
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

BaseVictorsMedicalTugo.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormCustom: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  intl: intlShape.isRequired,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  hasFormChanges: PropTypes.bool,
  setFormHasChanges: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectBaseVictorsMedicalTugo(),
  errors: makeSelectBaseVictorsMedicalTugoErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  hasFormChanges: makeSelectFormHasChanges(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormCustom: (fields) => dispatch(resetFormFields(fields)),
  setFormHasChanges: (hasFormChanges) => dispatch(setFormHasChanges(hasFormChanges)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'baseVictorsMedicalTugo', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(BaseVictorsMedicalTugo);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.BaseVictorsMedical/index.js